export default {
  http: {
    // 请求响应无数据时 向外抛出的错误
    ErrorNoneData: 'Request error, please try again later',
    // 成功提示语
    SuccessTip: 'SUCCESS',
    // 失败提示语
    ErrorTip: 'Fail',
    // 错误的modal框语言
    ErrorModalTip: {
      // 普通提示 标题
      title: '浏览期间超时',
      // 底部按钮文字
      positiveText: '确定',
      // 登录超时时的提示
      loginTimoutContent: '您已经离开一段时间!',
      loginTimoutContentText: '为了保证您信息安全，我们暂时关闭了您正在做的事情。',
      // 网络错误时modal标题
      NetworkErrorTitle: 'Network failure',
      // 网络错误时modal内容
      NetworkErrorContent: 'Please check whether your network connection is normal',
    },
    // 登录超时错误信息
    ErrorLoginTimeOutTip: 'Login timed out. Please log in again!',
    // 接口请求超时时的提示语
    ErrorApiTimeOut: 'The interface request timed out. Please refresh the page and try again!',
    status: {
      401: 'User does not have permission (incorrect token user name and password)!',
      403: 'The user is authorized, but access is forbidden!',
      404: 'Network request error. The resource was not found!',
      405: 'Network request error, request method not allowed!',
      408: 'Network request timeout',
      500: 'Server error, please contact administrator!',
      501: 'Network not implemented',
      502: 'Network errors',
      503: 'The service is unavailable and the server is temporarily overloaded or under maintenance!',
      504: 'Network timeout',
      505: 'The HTTP version does not support this request!',
    },
  },
};
